import { render, staticRenderFns } from "./formAdminTag.vue?vue&type=template&id=667c9ee0"
import script from "./formAdminTag.vue?vue&type=script&lang=js"
export * from "./formAdminTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports